<template>
  <el-row>
    <el-col :lg="10" :xl="8">
      <rest-form-item
        :label="$t('Integrations_Otp_SMS_Content_Sender_Name')"
        prop="params.sms.from"
        style="margin-bottom: 15px"
      >
        <el-autocomplete
          v-model="sms.from"
          :fetch-suggestions="querySearchFromAddr"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Otp_SMS_Content_Message')"
        prop="params.sms.text"
        :description="messageCounterMsg"
      >
        <otp-sms-message-input type="textarea" v-model="sms.text" attributes />
      </rest-form-item>
    </el-col>
    <el-col :lg="14" :xl="16" class="preview">
      <push-preview-section
        platform="ios"
        :text="previewMessageText"
        :title="sms.from"
        :app-name="appName"
        :app-icon="appIcon"
        :new-frame="true"
      />
    </el-col>
  </el-row>
</template>

<script>
import PushPreviewSection from '@/common/components/push/PushPreviewSection'
import OtpSmsMessageInput from '@/modules/integrations/types/otp/components/OtpSmsMessageInput'
import axios from 'axios'
import MessagesIosIcon from '@/img/icon/messages-ios.svg'
import RestFormItem from '@/common/components/rest/RestFormItem'
import SmsCounterHelper from '@/common/helpers/SmsCounterHelper'

export default {
  name: 'OtpSmsContent',
  components: {
    RestFormItem,
    OtpSmsMessageInput,
    PushPreviewSection
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      appIcon: MessagesIosIcon,
      appName: 'Messages',
      sms: {
        from: this.value.from || '',
        text: this.value.text || ''
      }
    }
  },
  created() {
    this.smsHelper = new SmsCounterHelper()
  },
  computed: {
    previewMessageText() {
      return (
        this.sms.text ||
        this.$t('Integrations_Otp_SMS_Preview_Text_Placeholder')
      )
    },
    messageCounter() {
      let text = this.sms.text

      if (this.shortenUrl) {
        text = this.replaceLinksToShort(text)
      }

      text = text.replaceAll(/{{(.*?)}}/g, '')

      return this.smsHelper.count(text)
    },
    messageCounterMsg() {
      let message =
        this.messageCounter.length +
        this.$t('Integrations_Otp_SMS_MessagePartOf') +
        this.messageCounter.perMessages +
        ' (' +
        this.messageCounter.messages +
        this.$t('Integrations_Otp_SMS_MessagePart')

      // add 'estimated' to the count message if a token is used in a message
      if (this.sms.text.match(/{{(.*?)}}/)) {
        message += this.$t('Integrations_Otp_SMS_MessagePartEstimated')
      } else {
        message += this.$t('Integrations_Otp_SMS_MessagePartActual')
      }

      return message
    }
  },
  methods: {
    querySearchFromAddr(queryString, cb) {
      axios
        .get('/api/sms/sms-from-name/autocomplete', {
          params: {
            project_id: this.$route.query.project_id,
            term: queryString
          }
        })
        .then(({ data }) => {
          cb(data)
        })
    },
    emitUpdate() {
      this.$emit('input', { ...this.sms })
    },

    checkMessageLength(text) {
      if (this.messageCounter.messages > this.smsHelper.maxMessages) {
        const maxLength =
          this.messageCounter.perMessage * this.smsHelper.maxMessages
        setTimeout(() => {
          this.sms.text = text.substring(0, maxLength)
        }, 100)
      }
    }
  },
  watch: {
    'sms.from': 'emitUpdate',
    'sms.text': {
      handler(text) {
        this.checkMessageLength(text)
        this.emitUpdate()
      }
    }
  }
}
</script>

<style scoped>
.preview {
  background-color: #f8fafc;
  padding-top: 30px;
  padding-bottom: 30px;
}
>>> .description {
  margin-top: -20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/otp/OtpSmsContent.vue